"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptinCode = void 0;
var OptinCode;
(function (OptinCode) {
    OptinCode["FOODI_TOS"] = "FOODI_TOS";
    OptinCode["FOODI_MARKETING"] = "FOODI_MARKETING";
    OptinCode["MAIL_FOODI_MARKETING"] = "MAIL_FOODI_MARKETING";
    OptinCode["MAIL_LOW_BALANCE"] = "MAIL_LOW_BALANCE";
    OptinCode["PUSH_FOODI_MARKETING"] = "PUSH_FOODI_MARKETING";
    OptinCode["PUSH_LOW_BALANCE"] = "PUSH_LOW_BALANCE";
    OptinCode["FOODI_ALLERGEN_DISCLAIMER"] = "FOODI_ALLERGEN_DISCLAIMER";
    OptinCode["AGE_VALIDATED"] = "AGE_VALIDATED";
})(OptinCode = exports.OptinCode || (exports.OptinCode = {}));
